import { render, staticRenderFns } from "./UDControls.vue?vue&type=template&id=0ee45b43&scoped=true&"
import script from "./UDControls.vue?vue&type=script&lang=js&"
export * from "./UDControls.vue?vue&type=script&lang=js&"
import style0 from "./UDControls.vue?vue&type=style&index=0&id=0ee45b43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee45b43",
  null
  
)

export default component.exports